import Section from "./Section";
import {Question} from "./Question";
import Condition from "./Condition";

export class ArraySectionItem {
    public static count = 0;
    constructor(public subject: Section, public additional: Section, public label: string = '', public compositeLabelQuestions: Array<Question> = [], public conditions: Condition[] = []) {
        conditions.forEach((condition: Condition) => condition.init());
        ArraySectionItem.count = ArraySectionItem.count + 1;
    }

    get incrementAdditional(): boolean {
        return this.subject.incrementAdditional;
    }

    public allConditionsFulfilled() {
        if(!this.additional.allConditionsFulfilled()){
            return false;
        }
        if (0 === this.conditions.length) {
            return true;
        }
        return this.conditions.every((condition: Condition) => condition.isFulfilled);
    }

    get additionalIndex(): number {
        return this.additional.additionalIndex;
    }
}